var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.71 25.72",
    style: {
      enableBackground: "new 0 0 92.71 25.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#282467;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0.94 10.93,25.72 0,25.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11,0 11,21.97 1.3,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.61,0 12.58,22.16 12.58,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.58,1.69 23.58,25.72 12.69,25.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.36,16.67 35.09,16.67 35.09,24.09 36.55,24.09 36.55,16.67 39.26,16.67 39.26,15.21 32.36,15.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.75,24.09 49.16,24.09 49.16,22.63 44.21,22.63 44.21,20.38 47.82,20.38 47.82,18.92 44.21,18.92  44.21,16.67 49.16,16.67 49.16,15.21 42.75,15.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59.51,15.21 57.72,15.21 55.61,18.21 53.49,15.21 51.7,15.21 54.71,19.49 51.48,24.09 53.27,24.09  55.61,20.76 57.94,24.09 59.73,24.09 56.5,19.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.55,16.67 64.29,16.67 64.29,24.09 65.75,24.09 65.75,16.67 68.46,16.67 68.46,15.21 61.55,15.21  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 15.21,
    className: "st0",
    width: 1.46,
    height: 8.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.85,15.21 77.39,15.21 77.39,24.09 82.81,24.09 82.81,22.63 78.85,22.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "92.71,16.67 92.71,15.21 86.3,15.21 86.3,24.09 92.71,24.09 92.71,22.63 87.76,22.63 87.76,20.38  91.37,20.38 91.37,18.92 87.76,18.92 87.76,16.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.28,1.63 36.43,8 33.75,2.07 33.57,1.63 32.36,1.63 32.36,10.52 33.82,10.52 33.82,5.76  35.76,10.08 35.95,10.52 36.91,10.52 39.03,5.76 39.04,10.52 40.5,10.52 40.49,1.63  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.39,6.81h2.68c-0.06,0.49-0.29,0.97-0.69,1.41c-0.52,0.56-1.1,0.83-1.77,0.84c-0.74,0-1.34-0.31-1.84-0.96 c-0.44-0.57-0.66-1.25-0.66-2.02c0-0.9,0.27-1.63,0.84-2.22c0.48-0.5,1.02-0.75,1.66-0.76c0.63-0.01,1.16,0.2,1.64,0.63 c0.18,0.17,0.32,0.35,0.41,0.52l0.11,0.2l1.31-0.65l-0.11-0.21c-0.32-0.63-0.86-1.14-1.6-1.51c-0.58-0.29-1.17-0.43-1.76-0.43 c-1.05,0-1.98,0.42-2.75,1.24c-0.8,0.88-1.2,1.96-1.21,3.2c0,1.25,0.4,2.33,1.2,3.19c0.78,0.82,1.7,1.24,2.76,1.25 c1.05,0,1.96-0.42,2.72-1.24c0.81-0.87,1.21-1.95,1.21-3.2V5.34h-4.16L56.39,6.81L56.39,6.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.17,2.07 67.97,1.63 67.02,1.63 63.6,9.5 63.16,10.52 64.75,10.52 67.49,4.21 70.04,10.08  70.24,10.52 71.82,10.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "80.12,10.52 81.59,10.52 81.59,1.63 80.12,1.63 80.12,5.34 76.39,5.34 76.39,1.63 74.93,1.63  74.93,10.52 76.39,10.52 76.39,6.81 80.12,6.81  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.08,
    y: 5.34,
    className: "st0",
    width: 3.76,
    height: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.08,
    y: 9.05,
    className: "st0",
    width: 5.1,
    height: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.08,
    y: 1.63,
    className: "st0",
    width: 5.1,
    height: 1.46
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e2f05ee5b3fb8d0d96d45f715851406.svg";
export { ForwardRef as ReactComponent };